// extracted by mini-css-extract-plugin
module.exports = {"article":"article_article__1iFsk","welcome":"article_welcome__2nQfn","half":"article_half__tiQ5G","third":"article_third__2-PmS","quarter":"article_quarter__3ASV2"};